function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
}


function showModal(modalId){
    var newsletterModal = new bootstrap.Modal(document.getElementById(modalId));
    newsletterModal.show();
}

var newsletterModal = document.getElementById('newsletterModal');
try {
    newsletterModal.addEventListener('hide.bs.modal', function(event){
        setCookie("newsletterShowed", "true", 30);
    })
} catch (error) {
}

function showNewsletterModal(){
    var newsletterSet = getCookie("newsletterShowed")
    if(newsletterSet == ""){
        showModal('newsletterModal')
        
    }else{

    }
}

showNewsletterModal()